export const getQuery = (namespace: string) => {
  if (process.env.SSR) return null;
  const url = window.location.search;
  const re = new RegExp(`[?&]${namespace}(=([^&#]*)|&|#|$)`);
  const results = re.exec(url);

  return !results || !results[2] ? null : results[2].replace(/\+/g, ' ');
};

export const getGuidFromPath = (path: string) => {
  const result = /((\w{4,12}-?)){5}/.exec(path);
  return result ? result[0] : null;
};
